// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"3eb71359","590":"badfd419","655":"93cde0f2"}[chunkId] + ".chunk.js";
};